module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am612-9d1cf76e62de23cc3c8fca623dea86f1.jpg";